/* eslint-disable indent */
import styled from 'styled-components';
import { ErrorMessage as FormikErrorMessage } from 'formik';

import colors from '../../styles/colors';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${({ hasLabel }) => (hasLabel ? '15px 0' : '0')};

  input {
    padding: ${({ isSmall }) => (isSmall ? '5px 0' : '10px 5px')};
    font-size: 16px;
  }

  select {
    padding: ${({ isSmall }) => (isSmall ? '5px 0' : '18px 0')};
  }

  input, select {
    background: ${colors.base.alpha};
    border: none;
    border-radius: 0;
    border-bottom: 1px solid ${colors.base.secondary2};
    color: ${colors.base.secondary2};
    outline: none;
    box-shadow: unset;

    margin-bottom: ${({ hasLabel }) => (hasLabel ? '0' : '25px')};
    width: ${({ hasLabel }) => (hasLabel ? 'auto' : '100%')};

    line-height: 148%;

    &.is-invalid {
      background-image: none;
    }

    &::placeholder {
      opacity: 0.34;
    }
    
    &:placeholder-shown {
      border-bottom: 1px solid ${colors.shades.gamma3};
    }

    &:focus, &.is-invalid:focus {
      line-height: 148%;
      background: ${colors.base.alpha};
      border: none;
      border-bottom: 1px solid ${colors.base.secondary2};
      outline: none;
      box-shadow: unset;
    }
  }

  input[type="checkbox"] {
    border: 1px solid ${colors.base.secondary2};
    user-select: none;
    width: 18px;
    height: 18px;
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
  }

  label {
    margin-left: 13px;
    margin-bottom: 20px;
  }

  .onboarding-phone-input {
    width: 100%;
  }

  .onboarding-phone-input .input-wrapper {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    flex-direction: column;
    background-color: ${({ $isDarkTheme, $filled }) => {
      if ($isDarkTheme) {
        return $filled ? colors.shades.dark3 : colors.shades.dark5;
      }
      return $filled ? colors.shades.alpha2 : colors.base.alpha;
    }};
    border: 1px solid ${colors.shades.gamma10};
    border-radius: 4px;
    padding: 12px;
    transition: all 0.2s ease-in-out;

    ${({ $hasError }) => $hasError && `
      border-color: ${colors.base.danger};
    `}

    color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
    font-size: 16px;

    &::placeholder {
      color: ${colors.shades.gamma10};
      opacity: 0.7;
    }

    &:hover {
      border-color: ${colors.shades.gamma7};
    }

    &:focus-within {
      border-color: ${colors.shades.gamma7};
    }

    select {
      background: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark3 : colors.shades.alpha2)};
      color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
    }

    input {
      margin: 0;
      padding: 4px 0 4px 4px;
      line-height: 16px;
      border: none;
      color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
      background-color: ${({ $isDarkTheme, $filled }) => {
        if ($isDarkTheme) {
          return $filled ? colors.shades.dark3 : colors.shades.dark5;
        }
        return $filled ? colors.shades.alpha2 : colors.base.alpha;
      }};

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:autofill,
      &:autofill:hover,
      &:autofill:focus {
        -webkit-text-fill-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
        caret-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
        transition: 
          background-color 5000s ease-in-out 0s,
          color 5000s ease-in-out 0s,
          -webkit-text-fill-color 5000s ease-in-out 0s;
        background-color: ${({ $isDarkTheme, $filled }) => {
          if ($isDarkTheme) {
            return $filled ? colors.shades.dark3 : colors.shades.dark2;
          }
          return $filled ? colors.shades.alpha2 : colors.base.alpha;
        }}  !important;
      }
    }
    
    label {
      margin-bottom: 4px;
      margin-left: 0;
      color: ${colors.shades.gamma10};
      font-size: 14px;
      line-height: 1;
      width: 100%;
    }
  }

  .onboarding-phone-input .error-message {
    position: unset;
    margin-top: 4px;
    width: 100%;
    font-size: 12px;
  }
`;

const ErrorMessage = styled(FormikErrorMessage)`
  position: absolute;
  top: calc(100% - 25px);
  margin-top: 0;
  font-size: 14px;
  color: ${colors.base.danger};
`;

export default Container;
export { ErrorMessage };
